export const messages_hr = {
  error_default: "Nešto je pošlo po zlu :(",
  error_oops: "Oops!",
  error_options: "Razmotrite jednu od sljedećih akcija",
  username_taken: "Korisničko ime je već zauzeto",
  email_taken: "Email adresa je već zauzeta",
  passwords_not_matching: "Lozinke ne odgovaraju",
  password_too_short: "Lozinka mora sadržavati najmanje {0} znakova",
  password_needs_digit: "Lozinka mora sadržavati barem jednu znamenku",
  password_needs_uppercased: "Lozinka mora sadržavati barem jedno veliko slovo",
  password_needs_lowercased: "Lozinka mora sadržavati barem jedno malo slovo",
  password_not_allowed_special:
    "Lozinka ne smije sadržavati niti jedan posebni znak",
  registration_succes: "Uspješno ste se registrirali u sustav!",
  serverError:
    "Dogodila se pogreška u komunikaciji s poslužiteljem! Molimo pokušajte ponovo ili se obratite administratoru sustava.",
  delete_selected_confirm_message:
    "Jeste li sigurni da želite obrisati označene stavke?",
  documentsDeleteSuccess: "Dokument(i) uspješno obrisan(i)!",
  documentsUploadSuccess: "Dokument(i) uspješno učitan(i)!",
  nothingSelectedMessage:
    "Nema označene stavke. Označite stavku koju želite obrisati.",
  changesNotSavedMessage:
    "Promjene nisu spremljene, jeste li sigurni da želite napustiti stranicu?",
  reactivate_confirm_message: "Jeste li sigurni da želite reaktivirati stavku?",
  deactivate_confirm_message: "Jeste li sigurni da želite deaktivirati stavku?",
  clientError:
    "Dogodila se pogreška na klijentu! Molimo pokušajte ponovo ili se obratite administratoru sustava.",
  settingsSaveSuccess: "Postavke uspješno spremljene!",
  existingElementAdditionWarning: "Pokušali ste dodati već postojeću stavku!",
  notificationsUnsupportedMessage:
    "Ovaj web-preglednik ne podržava obavijesti. Promijenite preglednik ili pokušajte ažurirati trenutni ako želite primati obavijesti.",
  webSocketsUnsupportedMessage:
    "Ovaj web-preglednik ne podržava korištenje web-socket-a. Promijenite preglednik ili pokušajte ažurirati trenutni ako želite primati obavijesti u stvarnom vremenu.",
  disabledSaveButtonTooltip:
    "Spremanje trenutno nije dozvoljeno. Potrebno je popuniti sve obavezne podatke.",
  usernamePasswordMandatory: "Potrebno je unijeti korisničko ime i lozinku!",
  "searchable.true": "Sadržaj ovoga dokumenta je moguće pretraživati.",
  "searchable.false":
    "Sadržaj ovoga dokumenta nije moguće pretraživati. Za dodatna pojašnjenja obratite se administratoru.",
  "searchable.wait":
    "Dokument se trenutačno obrađuje. Molim pričekajte i provjerite kasnije.",
  changesNotSavedWarn: "Imate promjene koje će biti izgubljene.",
  download_confirm_message: "Jeste li sigurni da želite preuzeti dokument?",
  download_url_confirm_message: "Jeste li sigurni da želite preuzeti multimedijski dokument?",
  preview_url_confirm_message: "Jeste li sigurni da želite pregledati multimedijski dokument?",
  empty_files_unzipped_message:
    "Datoteka je uspješno otpakirana i spremljena, ali ovi dokumenti unutar su bili prazni i zbog toga nisu spremljeni:"
};
